import { condition } from "./condition";
export const reducer = (state, action) => {
  switch (action.type) {
    case condition.LOGINTYPE:
      return {
        ...state,
        loginuserType: action?.payload,
      };
    case condition.LANGUAGESELECT:
      return {
        ...state,
        selectedLanguage: action?.payload,
      };
    case condition.MODALCONTENT:
      return {
        ...state,
        modalcontent: action?.payload,
      };
    case condition.MODALSHOWHIDE:
      return {
        ...state,
        showModal: action?.payload,
      };
    case condition.CLEARCHAT:
      return {
        ...state,
        activities: action?.payload,
      };

    case condition.SETMESSGES:
      return {
        ...state,
        messages: [...state.messages, action?.payload],
      };
    case condition.UPDATEMESSGES:
      const { key, data } = action.payload;
      const updatedMessages = state.messages.map((msg) =>
        msg.key === key
          ? {
            ...msg,
            ...data
          }
          : msg
      );
      return {
        ...state,
        messages: updatedMessages,
      };
    case condition.RESETMESSAGES:
      return {
        ...state,
        messages: [],
      };
    case condition.SETAUTOCOMPLETEDATA:
      return {
        ...state,
        autocompleteData: action?.payload,
      };
    case condition.SETAUTHTOKEN:
      return {
        ...state,
        authToken: action?.payload,
      };
    case condition.SETISFIRSTTIME:
      return {
        ...state,
        isFirstTime: action?.payload,
      };
    case condition.ISMESSAGESUBMITTED:
      return {
        ...state,
        isMessageSubmitted: action?.payload,
      };
    case condition.SETRECENTSEARCHES:
      return {
        ...state,
        recentSearches: action?.payload,
      };
    case condition.UPDATELASTMESSAGE:
      const payload = action.payload;
      const updatedMessagesWithLastMessage = state.messages.map((msg, index) => {
        return (index === state.messages.length - 1
          ? {
            ...msg,
            ...payload
          }
          : msg)
      }
      );
      return {
        ...state,
        messages: updatedMessagesWithLastMessage,
      };
    case condition.SETMODE:
      return {
        ...state,
        mode: action?.payload,
      };
    case condition.SETSOURCE:
      return {
        ...state,
        source: action?.payload,
      };
    case condition.SETTRANSCRIPTION:
      return {
        ...state,
        transcription: action?.payload,
      };
    case condition.SETPROMPTS:
      return {
        ...state,
        prompts: action?.payload,
      };

    // condition setting nudge flow
    case condition.SETNUDGEFLOW:
      return {
        ...state,
        nudgeFlow: action?.payload,
      };
  // condition setting digi gold nudge flow
    case condition.SETDIGIGOLDFLOW:
      return {
        ...state,
        digiGoldFlow: action?.payload,
      };

    case condition.SETCHANNEL:
      return {
        ...state,
        channel: action?.payload,
      };

    default:
      return state;
  }
};
